import styled from 'styled-components';

export const Container = styled.div<{
  $margin: string;
}>`
  margin: ${({ $margin }) => $margin};
`;

export const CompanyDateContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Value = styled.p`
  font-size: 10px;
  line-height: 13px;
  margin: 0;
`;

export const ValueHighlighted = styled(Value)`
  font-weight: 600;
  margin: 0;
  flex: 1;
  font-size: 10px;
  line-height: 13px;
`;

export const List = styled.ul`
  margin: 0;
  padding: 5px 0 0 20px;
`;

export const ListItem = styled.li`
  font-size: 10px;
  line-height: 13px;
`;

export const Date = styled.div`
  font-size: 10px;
  line-height: 13px;
  margin: 0;
  color: var(--mainColor);
  font-weight: 700;
`;
